import React from 'react';

import { EventUnion, UpdateEventStatusTypeEnum } from '@/types/schema';

import { ActionDialog, DialogActions } from '../../types';
import ArchiveSessionDialog from '../ArchiveSessionDialog';
import DeleteSessionDialog from '../DeleteSessionDialog';
import RescheduleSessionModal from '../RescheduleSessionModal';
import ShareSessionDialog from '../ShareSessionDialog';

function ActionDialogs({
  Image,
  onAction,
  inViewActionDialog,
  event,
}: {
  Image: JSX.Element;
  onAction: (props: {
    dialogAction: DialogActions;
    message?: string;
    updateType?: UpdateEventStatusTypeEnum;
  }) => void;
  inViewActionDialog: ActionDialog | null;
  event: EventUnion;
}) {
  const onClose = () => onAction({ dialogAction: DialogActions.Close });

  if (inViewActionDialog === ActionDialog.Archive) {
    return <ArchiveSessionDialog Image={Image} event={event} onAction={onAction} />;
  }

  if (inViewActionDialog === ActionDialog.Share) {
    return <ShareSessionDialog event={event} onClose={onClose} />;
  }

  if (inViewActionDialog === ActionDialog.Reschedule) {
    return <RescheduleSessionModal event={event} onClose={onClose} />;
  }

  if (inViewActionDialog === ActionDialog.Delete) {
    return <DeleteSessionDialog Image={Image} event={event} onAction={onAction} />;
  }

  return null;
}

export default React.memo(ActionDialogs);
